import React from 'react';
import './Login.css';
import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { useLocation } from 'react-router';
import { useSubmitResetPasswordForm } from './authActions';
import FormField from '../form/FormField';
import { passwordMaximumLimit } from '../common/validation/helper';
import { SalvBanner, SalvBannerType, SalvButton } from '@salvapp/ui-components';
import { ExternalContainer } from '../common/ExternalContainer';
import { Col } from 'react-bootstrap';

const validationSchema = Yup.object().shape({
  password: Yup.string().required('Required').max(passwordMaximumLimit.value, passwordMaximumLimit.message),
  confirmPassword: Yup.string()
    .required('Required')
    .oneOf([Yup.ref('password'), ''], 'Passwords must match'),
});

export interface ResetPasswordFormValues {
  token: string | null;
  password: string;
  confirmPassword: string;
}

export const ResetPassword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialValues: ResetPasswordFormValues = {
    token: params.get('token'),
    password: '',
    confirmPassword: '',
  };

  const { submitResetPasswordForm } = useSubmitResetPasswordForm();

  return (
    <ExternalContainer size={50}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, helpers) => submitResetPasswordForm(values, helpers)}
      >
        {({ isSubmitting, status }: FormikProps<ResetPasswordFormValues>) => (
          <Form>
            <div id='password-reset'>
              <FormField
                id='password'
                name='password'
                type='password'
                label='New password'
                placeholder='Enter new password'
              />

              <FormField
                id='confirmPassword'
                name='confirmPassword'
                type='password'
                label='Confirm Password'
                placeholder='Enter your password again'
              />
            </div>

            <Col md={{ offset: 3, span: 6 }} className='text-center'>
              <SalvButton type='submit' variant='primary' disabled={isSubmitting} label={'Set password'} />
            </Col>

            {status && status.message && (
              <SalvBanner
                message={status.message}
                type={status.success ? SalvBannerType.SUCCESS : SalvBannerType.DANGER}
              ></SalvBanner>
            )}
          </Form>
        )}
      </Formik>
    </ExternalContainer>
  );
};

export default ResetPassword;
